import styled from 'styled-components'
import { StyledButton, StyledBar, Loader } from '../../../utils/style/Atoms'
import colors from '../../../utils/style/colors'
import { useTheme, useFetch } from '../../../utils/hooks'
import { useState, useEffect } from 'react'
import circleGold from '../../../../src/assets/circleGOLD.svg'
import circleOrange from '../../../../src/assets/circleORANGE.svg'

const ContentWrapper = styled.section`
    background-color: ${({ theme }) => (theme === 'light' ? colors.celadon : colors.backgroundDark)};
    margin: auto;
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    gap: 20px;
    transition: all 200ms;
    @media screen and (max-width: 980px) {
        flex-direction: column;
        margin: auto;
        padding: 20px 20px;
        gap: 0;
    }
    @media screen and (max-width: 480px) {
        padding: 10px 20px;
    }
`

const MainSection = styled.section`
    background-color: ${({ theme }) => (theme === 'light' ? `none` : `none`)};
    display: flex;
    flex-wrap: wrap;
    flex-direction: column;
    justify-content: center;
    align-content: center;
    transition: all 200ms;
    padding: 30px;
    @media screen and (min-width: 1140px) {
        width: 50%;
        align-items: flex-start;
        height: 580px;
    }
    @media screen and (max-width: 1140px) {
        width: 40%;
    }
    @media screen and (max-width: 980px) {
        width: 100%;
        text-align: center;
        padding: 0;
    }
    ${StyledButton} {
        margin-top : 20px;
        box-shadow: ${({ theme }) => (theme === 'light' ? `4px 4px 8px ${colors.black}` : `8px 8px 12px ${colors.black}` )};
        &:hover {
            box-shadow: ${({ theme }) => (theme === 'light' ? `6px 6px 10px ${colors.black}` : `8px 8px 12px ${colors.black}` )};
        }
        @media screen and (max-width: 980px) {
            margin: 20px auto;
        }
        @media screen and (max-width: 480px) {
            margin-top: 10px;
        }
    }
    ${StyledBar} {
        margin: 0 0 10px 0;
        @media screen and (max-width: 980px) {
            margin: 10px auto;
        }
    }
`

const Title = styled.h2`
    line-height: 50px;
    color: ${({ theme }) => (theme === 'light' ? colors.white : colors.white)};
    transition: all 200ms;
    @media screen and (max-width: 980px) {
        margin: auto;
        text-align: center;
    }
`

const Description = styled.p`
    color: ${({ theme }) => (theme === 'light' ? colors.white : colors.white)};
    transition: all 200ms;
    text-wrap: wrap;
    max-width: 95%;
    margin-top: 10px;
    text-align: justify;
    @media screen and (min-width: 981px) {
        max-width: 500px;
    }
    @media screen and (max-width: 980px) {
        text-align: justify;
        margin: 10px auto;
    }
    @media screen and (max-width: 480px) {
        margin-bottom: 0px;
    }
`

const AdvantagesList = styled.ul`
    transition: all 200ms
    &:after {
        box-sizing: initial;
    }
    &:before {
        box-sizing: initial;
    }
    @media screen and (min-width: 660px) and (max-width: 980px) {
        margin-left: 10px;
    }
`

const AdvantagesExample = styled.li`
    color: ${({ theme }) => (theme === 'light' ? colors.white : colors.white)};
    transition: all 200ms;
    text-wrap: wrap;
    text-align: justify;
    display: flex;
    margin-top: 10px;
    list-style-type: none;
    @media screen and (min-width: 981px) {
        max-width: 480px;
    }
    @media screen and (max-width: 1140px) {
        margin: 20px 10px 10px 10px;
    }
    @media screen and (max-width: 980px) {
        margin: 10px 20px 10px 10px;
        text-align: start;
        &:first-child {
            margin-top: 15px;
        }
    }
    @media screen and (max-width: 480px) {
        margin: 5px 5px 5px;
    }
    &:before {
        content:'';
        padding: 0 0 0 20px;
        background-image: url(${({ theme }) => (theme === 'dark' ? circleGold : circleOrange)});
        position: relative;
        background-repeat: no-repeat;
        width: 8px;
        height: 8px;
        top: 10px;
    }
`

const PictureMainSection = styled.section`
    z-index: 0;
    width: 50%;
    padding: 20px;
    margin: auto;
    @media screen and (max-width: 1140px) {
        width: 60%;
    }
    @media screen and (max-width: 980px) {
        width: 100%;
        padding: 0;
    }
`


const LoaderWrapper = styled.section`
    display: flex;
    justify-content: center;
    align-items: center;
`

const CardsContainer = styled.section`
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-content: center;
    flex-wrap: wrap;
    gap: 30px;
    max-width: 600px;
    margin: auto;
    padding: 20px 0;
    @media screen and (max-width: 1140 px) {
        width: 60%;
    }
    @media screen and (max-width: 340px) {
        padding: 10px;
        gap: 20px;
    }
`

const Picture = styled.img`
    width: 240px;
    height: 180px;
    object-fit: fill;
    transition: all 200ms;
    @media screen and (min-width: 601px) and (max-width: 1140px) {
        max-width: 200px;
        max-height: 140px;
        margin: 0;
        padding-top: 0;
    }
    @media screen and (min-width: 481px) and (max-width: 600px) {
        max-width: 180px;
        max-height: 135px;
        margin: 0;
        padding-top: 0;
    }
    @media screen and (max-width: 480px) {
        max-width: 140px;
        max-height: 105px;
    }
    @media screen and (max-width: 340px) {
        max-width: 120px;
        max-height: 90px;
    }
    @media screen and (max-width: 280px) {
        max-width: 100px;
        max-height: 75px;
    }
`

function Debug() {
  const { theme } = useTheme()
  const { isLoading, error } = useFetch(`https://www.becom-in.fr/api/webdev?id=6`)
  const [debugData, setDebugData] = useState({})

  useEffect(() => {

    let isMounted = true

    fetch(`https://www.becom-in.fr/api/webdev?id=6`)
      .then((response) => response.json())
      .then((jsonResponse) => {
            if (isMounted) {
                setDebugData(jsonResponse?.webdevData)
            }
        })
        return () => isMounted = false
    }, [])

  const {
    type,
    description,
    advantages,
    pictures,
  } = debugData

  if (error) {
    return <span>Oups, il y a eu un problème avec les données (Débogage)</span>
  }

  return (
    
    <ContentWrapper theme={theme}>
        <MainSection theme={theme}>
            <Title theme={theme}>
                {type}
            </Title>
            <StyledBar theme={theme}></StyledBar>
            <Description theme={theme}>
                {description}
            </Description>
            <AdvantagesList >
                {advantages && advantages.map((advantage) => (
                    <AdvantagesExample theme={theme} key={`{${advantage}`}>
                        {advantage}
                    </AdvantagesExample>
                ))}
            </AdvantagesList>
            <a href={'#contact'} title='Contactez-nous'>
                <StyledButton theme={theme}>Nous contacter</StyledButton>
            </a>
        </MainSection>

        <PictureMainSection>
            {isLoading ? (
                <LoaderWrapper>
                    <Loader theme={theme} data-testid="loader" />
                </LoaderWrapper>
            ) : (
                <CardsContainer>
                    {pictures && pictures.map((picture) => (
                    <Picture
                        src={picture.url}
                        key={`picture-${picture.url}-debug-code`}
                        className={`card-${picture.id}`}
                        alt={`picture-debug-code-development-becom'in-${picture.id}`}
                    />
                    ))}
                </CardsContainer>
            )}
        </PictureMainSection>
    </ContentWrapper>
  )
}

export default Debug